import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AuditHistory from 'components/modules/shipments/AuditHistory';
import LoadingIndicator from 'components/v2/LoadingIndicator';
import { getCustomerQuickPayAuditEvents } from 'utils/CustomersAPIUtils';
import { showToast } from 'stores/ToastStore';
import { useTranslation } from 'react-i18next';
const History = () => {
    const { t } = useTranslation();
    const { id: accountId } = useParams();
    const [contractAudits, setContractAudits] = useState({
        items: [],
        totalCount: 10,
    });
    const [isLoading, setIsLoading] = useState(true);
    const fetchCustomerQuickPayAuditEvents = async () => {
        var _a, _b;
        try {
            const audits = await ((_b = (_a = (await getCustomerQuickPayAuditEvents(accountId, { page: 1, perPage: 200 }))) === null || _a === void 0 ? void 0 : _a.audits) === null || _b === void 0 ? void 0 : _b.items);
            setContractAudits(audits);
        }
        catch (e) {
            showToast('', t('FETCH_FAILED'), 'error');
        }
        finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        fetchCustomerQuickPayAuditEvents();
    }, []);
    return !isLoading ? (React.createElement(AuditHistory, { audits: contractAudits, isLoading: isLoading, paginate: true, keepDuplicates: true })) : (React.createElement(LoadingIndicator, null));
};
export default History;
